import React from "react";
import ThemeToggle from "./ThemeToggle";

const TopNav = () => {
    return (
        <div className="bg-gray-800 text-white p-4 flex justify-between items-center">
            <div className="text-xl font-bold">Admin Dashboard</div>
            <div className="flex items-center space-x-4">
                <ThemeToggle />
                <button className="px-4 py-2 bg-blue-600 rounded">Profile</button>
            </div>
        </div>
    );
};

export default TopNav;
